export default "__VITE_ASSET__jfCtq4gr__"